<script setup lang="ts">
import IconSubmit from "@/icons/IconSubmit.vue";
import {useCartStore} from "@/stores/cartStore";
import {ref} from "vue";
const code = ref('');
const cartStore = useCartStore();
const handleSubmit = async () => {
  const response = await cartStore.submitDiscountCode(code.value);
  if(response) {
    code.value = '';
  }
}
</script>
<template>
  <div class="discount-box discount-box_not-customer">
    <div :class="{
      'coupon-code-message coupon-code-message_confirm': true,
      'is-active': cartStore.discountData.code && cartStore.discountData.success && cartStore.discountData && cartStore.discountData.totals && cartStore.discountData.totals.discount > 0
    }">
      <p class="coupon-code-message__main">Your coupon <strong>{{ cartStore.discountData.code }}</strong> has been successfully applied</p>
    </div>
    <input type="text" class="discount-box__input input" placeholder="Promo Code" data-type="discount-code" autocomplete="off" :disabled="!cartStore.isLineItemsFilled" v-model="code">
    <button class="discount-box-btn Button Button--primary" :disabled="!cartStore.isLineItemsFilled || !code" @click="handleSubmit">
      <IconSubmit/>
      <span class="hidden-phone">Apply</span>
    </button>
  </div>
</template>